import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { entitiesApi } from "@/lib/api";
import { useCurrency } from "@/lib/currency";
import { PageShell } from "./Overview";
import { StatusPill } from "./Overview";
import { ArrowUpRight, Plus } from "lucide-react";

const Entities = () => {
  const [rows, setRows] = useState([]);
  const [loaded, setLoaded] = useState(false);
  const { format } = useCurrency();
  useEffect(() => {
    entitiesApi.list().then((r) => { setRows(r); setLoaded(true); }).catch(() => setLoaded(true));
  }, []);

  return (
    <PageShell title="Entities" subtitle={`${rows.length} total`}
      action={
        <Link to="/app/register" data-testid="entities-new-button"
          className="inline-flex items-center gap-2 bg-artha-amber text-artha-ink px-5 py-3 text-sm tracking-tight hover:bg-artha-cream transition-colors">
          <Plus size={14} /> New entity
        </Link>}
    >
      {loaded && rows.length === 0 && (
        <div className="border border-dashed border-border-subtle p-16 text-center">
          <div className="h-display text-3xl italic text-ink-muted">No entities yet.</div>
          <p className="mt-3 text-sm text-ink-muted">Begin your first incorporation in under 5 minutes.</p>
          <Link to="/app/register" data-testid="empty-state-register-link"
            className="mt-6 inline-flex items-center gap-2 bg-artha-amber text-artha-ink px-5 py-3 text-sm hover:bg-artha-cream transition-colors">
            Start incorporation <ArrowUpRight size={14} />
          </Link>
        </div>
      )}
      {rows.length > 0 && (
        <div className="border border-border-subtle divide-y divide-border-subtle">
          {rows.map((e) => (
            <Link key={e.id} to={`/app/entities/${e.id}`} data-testid={`entity-row-${e.id}`}
              className="grid grid-cols-12 gap-4 items-center px-6 py-5 hover:bg-surface-card transition-colors">
              <div className="col-span-5">
                <div className="text-base text-ink-body">{e.company_name}</div>
                <div className="text-xs text-ink-muted mt-1 font-mono-accent uppercase tracking-[0.18em]">
                  {e.entity_type_name}
                </div>
              </div>
              <div className="col-span-3 text-sm text-ink-muted flex items-center gap-2">
                <span className="text-base">{flagFor(e.country)}</span>{e.country_name}
              </div>
              <div className="col-span-2 font-mono-accent text-sm text-artha-amber">{format(e.price)}</div>
              <div className="col-span-2 flex justify-end"><StatusPill status={e.status} /></div>
            </Link>
          ))}
        </div>
      )}
    </PageShell>
  );
};

const flagFor = (code) => ({ IN: "🇮🇳", US: "🇺🇸", GB: "🇬🇧", AE: "🇦🇪", SG: "🇸🇬", EE: "🇪🇪", CH: "🇨🇭" }[code] || "");
export default Entities;
